import { ImageNotSupported } from '@mui/icons-material';
import { Box } from '@mui/material';

type Props = {
  src?: string;
  width?: number;
  height?: number;
  showPlaceholder?: boolean;
  rounded?: boolean;
  filtered?: boolean;
  backgroundSize?: 'contain' | 'cover';
};

const Image = ({
  src,
  width = 40,
  height,
  showPlaceholder = true,
  rounded,
  filtered,
  backgroundSize = 'cover',
}: Props) => {
  if (!src) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width,
          height: height || width,
          borderRadius: 1,
          borderWidth: 2,
          borderColor: (t) => t.palette.grey[500],
          flexShrink: 0,
        }}
      >
        {showPlaceholder && <ImageNotSupported color="disabled" />}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'block',
        borderRadius: rounded ? width / 2 : 1,
        width,
        height: height || width,
        backgroundImage: `url(${src})`,
        backgroundSize,
        flexShrink: 0,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: filtered ? 'grayscale(100%)' : 'none',
      }}
    />
  );
};

export default Image;
